<template>
    <div>
        <div v-if="userCanRateSubscription" class="rate-arrangement__container">
            <div class="divider--container rate-arrangement__left-container">
                <div class="divider-white--top rate-arrangement__mobile-divider z-10"></div>
                <h2 class="rate-arrangement__heading" v-text="displayDate"></h2>
                <p class="rate-arrangement__subheading" v-if="recentlyDelivered" v-text="$t('RATE_ARRANGEMENT_WAIT_FOR_BLOOM')"></p>
                <img class="rate-arrangement__image" :src="imageSrc"/>
                <div class="divider-paper--bottom rate-arrangement__mobile-divider"></div>
            </div>
            <div class="rate-arrangement__right-container">
                <rate-flowers-form
                    :order-id="arrangementToRate.order.id" :courierName="arrangementToRate.order.courier_name">
                </rate-flowers-form>
            </div>
        </div>
        <div v-else class="container no-arrangements__container">
            <h2 v-text="$t('RATE_ARRANGEMENT_NO_FLOWERS')"></h2>
            <p v-text="$t('RATE_ARRANGEMENT_WE_ARE_LOVING')"></p>
            <p v-text="$t('RATE_ARRANGEMENT_A_LOOSE')"></p>
            <router-link class="btn btn--primary mt-2" :to="{name: 'account.free-flowers'}">
                {{ $t('RATE_ARRANGEMENT_FREE_FLOWERS') }}
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { format, isAfter, subDays } from 'date-fns';
import RateFlowersForm from '@/components/forms/account/RateFlowersForm';

export default {
    name: 'RateArrangement',
    computed: {
        ...mapGetters({
            activeSubscription: 'subscription/getActiveSubscription',
            arrangementsUserCanRate: 'cms/getRateableArrangements',
        }),

        arrangementToRate() {
            return (Object.values(this.arrangementsUserCanRate) || []).find(item => item.subscription.id === this.activeSubscription.id);
        },

        userCanRateSubscription() {
            return typeof this.arrangementToRate !== 'undefined';
        },
        imageSrc() {
            const src = this.arrangementToRate.image_url;
            return src;
        },
        displayDate() {
            const deliveryDate = this.arrangementToRate.order.delivery_date;
            const formattedDate = format(new Date(deliveryDate), 'EEEE do MMMM');
            return formattedDate;
        },
        recentlyDelivered() {
            const deliveryDate = new Date(this.arrangementToRate.order.delivery_date);
            const threeDaysAgo = subDays(new Date(), 3);
            return isAfter(deliveryDate, threeDaysAgo);
        },
    },
    components: {
        RateFlowersForm,
    },
};
</script>

<style lang="scss" scoped>
.rate-arrangement {
    &__container {
        margin: 0 auto;
        padding-bottom: 40px;
        width: 100%;
        @screen md {
            display: flex;
        }
    }
    &__left-container {
        width: 100%;
        padding: 24px 0;
        text-align: center;
        @screen md {
            width: 50%;
            padding: 24px 16px 0;
        }
    }

    &__right-container {
        width: 100%;
        padding: 0 16px;
        @screen md {
            width: 50%;
            padding-top: 24px;
        }
    }

    &__heading {
        font-size: 30px;
    }

    &__subheading {
        font-size: 18px;
    }

    &__image {
        width: 100%;
        max-height: 325px;
        object-fit: contain;
        @screen md {
            max-height: 450px;
        }
    }

    &__mobile-divider {
        display: block;
        @screen md {
            display: none;
        }
    }
}
.no-arrangements {
    &__container {
        width: 100%;
        padding: 32px 16px;
        margin: 0 auto;
        text-align: center;
        @screen md {
            width: 80%;
        }
    }
}

</style>
